<script lang="ts">
	import type { HTMLAttributes } from 'svelte/elements';

	let props: HTMLAttributes<SVGElement> = $props();
</script>

<svg viewBox="0 0 93 20" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
	<mask id="mask0_3351_11380" style="mask-type:luminance" maskUnits="userSpaceOnUse" x="42" y="0">
		<path d="M92.8066 0H42.684V19.9999H92.8066V0Z" fill="white" />
	</mask>
	<g mask="url(#mask0_3351_11380)">
		<path
			fill-rule="evenodd"
			clip-rule="evenodd"
			d="M45.9703 18.2772C45.3504 18.2772 45.0346 17.972 45.0346 17.4702C45.0346 16.5345 46.0779 16.2199 47.9808 16.0176C47.9808 17.2644 47.1375 18.2772 45.9644 18.2772H45.9703ZM46.789 11.2655C45.4288 11.2655 43.865 11.9053 43.0159 12.5825L43.7913 14.2199C44.472 13.5965 45.5726 13.0632 46.5656 13.0632C47.5094 13.0632 48.0311 13.379 48.0311 14.0153C48.0311 14.4422 47.6861 14.6585 47.0334 14.7439C44.5937 15.0597 42.6814 15.7334 42.6814 17.6129C42.6814 19.1029 43.7422 20.0047 45.3995 20.0047C46.5831 20.0047 47.6358 19.3474 48.1363 18.4842V19.7708H50.3422V14.3802C50.3422 12.158 48.7995 11.2609 46.7902 11.2609L46.789 11.2655Z"
			fill="black"
		/>
		<path
			fill-rule="evenodd"
			clip-rule="evenodd"
			d="M68.9276 11.5077V19.7602H71.2878V15.7836C71.2878 13.8948 72.4317 13.3392 73.2282 13.3392C73.5868 13.3364 73.938 13.4403 74.2375 13.6375L74.6691 11.4562C74.3346 11.3223 73.9766 11.2575 73.6165 11.2656C72.4036 11.2656 71.641 11.8024 71.1381 12.8948V11.5077H68.9276Z"
			fill="black"
		/>
		<path
			fill-rule="evenodd"
			clip-rule="evenodd"
			d="M85.6071 11.2655C84.3592 11.2655 83.4259 12.0024 82.9405 12.7135C82.4902 11.7953 81.537 11.2655 80.3908 11.2655C79.144 11.2655 78.2797 11.9579 77.8809 12.7556V11.5076H75.6049V19.7602H77.9674V15.5111C77.9674 13.9907 78.7662 13.255 79.5113 13.255C80.1861 13.255 80.806 13.6912 80.806 14.8176V19.7602H83.1639V15.5111C83.1639 13.9684 83.9428 13.255 84.7229 13.255C85.3475 13.255 86.0095 13.7088 86.0095 14.8012V19.7602H88.3674V14.055C88.3674 12.2012 87.1194 11.2655 85.6118 11.2655"
			fill="black"
		/>
		<path
			fill-rule="evenodd"
			clip-rule="evenodd"
			d="M63.183 11.5076H61.045V10.669C61.045 9.57659 61.6684 9.26548 62.2052 9.26548C62.5718 9.27026 62.9321 9.36035 63.2579 9.52863L63.9854 7.86431C63.9854 7.86431 63.2473 7.38245 61.9058 7.38245C60.3982 7.38245 58.6825 8.23273 58.6825 10.9006V11.5076H55.1094V10.669C55.1094 9.57659 55.7316 9.26548 56.2696 9.26548C56.6367 9.26545 56.9983 9.35583 57.3222 9.52863L58.0497 7.86431C57.6158 7.61052 56.9176 7.38245 55.9714 7.38245C54.4638 7.38245 52.748 8.23273 52.748 10.9006V11.5076H51.3819V13.3274H52.7515V19.7601H55.1094V13.3274H58.6871V19.7601H61.045V13.3274H63.183V11.5076Z"
			fill="black"
		/>
		<path d="M66.948 11.5077H64.5924V19.7568H66.948V11.5077Z" fill="black" />
		<path
			fill-rule="evenodd"
			clip-rule="evenodd"
			d="M64.6779 10.1054H66.9855C68.3317 5.87271 72.8989 2.15226 78.3305 2.15226C84.9363 2.15226 90.645 7.18147 90.645 15.0107C90.6652 16.6177 90.4443 18.2187 89.9901 19.7603H92.2298L92.252 19.6832C92.6295 18.157 92.8157 16.5898 92.8064 15.0177C92.8064 6.28674 86.4439 0.00256348 78.3352 0.00256348C71.9656 0.00256348 66.2884 4.42359 64.6791 10.1078L64.6779 10.1054Z"
			fill="#4A4AF4"
		/>
	</g>
	<path d="M29.3507 0.170532H26.5433V19.991H29.3507V0.170532Z" fill="#158055" />
	<path d="M24.2051 0.17041H21.3977V19.9908H24.2051V0.17041Z" fill="#158055" />
	<path d="M19.0586 6.12939H16.2512V19.9917H19.0586V6.12939Z" fill="#158055" />
	<path
		d="M17.6297 3.23038L16.763 2.36235L17.6297 1.49433L18.4977 2.36235L17.6297 3.23038ZM17.6297 0C17.1625 0 16.7057 0.13855 16.3172 0.398129C15.9288 0.657708 15.626 1.02666 15.4472 1.45832C15.2684 1.88998 15.2216 2.36498 15.3127 2.82323C15.4039 3.28148 15.6289 3.70241 15.9593 4.03279C16.2896 4.36317 16.7106 4.58817 17.1688 4.67932C17.6271 4.77047 18.1021 4.72369 18.5337 4.54489C18.9654 4.36609 19.3343 4.0633 19.5939 3.67481C19.8535 3.28632 19.992 2.82958 19.992 2.36235C19.992 1.73582 19.7432 1.13495 19.3001 0.691918C18.8571 0.248891 18.2562 0 17.6297 0Z"
		fill="#158055"
	/>
	<path
		d="M5.56253 19.9931H8.35753V9.98877C8.35753 9.62086 8.50368 9.26802 8.76383 9.00787C9.02398 8.74772 9.37682 8.60157 9.74473 8.60157C10.1126 8.60157 10.4655 8.74772 10.7256 9.00787C10.9858 9.26802 11.1319 9.62086 11.1319 9.98877V19.9931H13.9201V9.99701C13.92 9.1913 13.6867 8.40282 13.2485 7.72669C12.8103 7.05057 12.1859 6.51566 11.4505 6.18651C10.7151 5.85735 9.90012 5.748 9.10395 5.87165C8.30779 5.9953 7.5644 6.34667 6.96347 6.88337C6.36295 6.34385 5.61886 5.99006 4.82135 5.86485C4.02385 5.73963 3.20714 5.84838 2.47018 6.1779C1.73322 6.50742 1.10763 7.04359 0.669199 7.72144C0.230772 8.39929 -0.00167801 9.18973 9.11904e-06 9.99701V19.9999H2.78814V9.99701C2.78814 9.6291 2.93429 9.27626 3.19444 9.01611C3.45459 8.75596 3.80743 8.60981 4.17533 8.60981C4.54324 8.60981 4.89608 8.75596 5.15623 9.01611C5.41638 9.27626 5.56253 9.6291 5.56253 9.99701V19.9931Z"
		fill="#158055"
	/>
	<line
		x1="36.2674"
		y1="-1.09279e-08"
		x2="36.2674"
		y2="19.9999"
		stroke="#927866"
		stroke-width="0.5"
	/>
</svg>
